import { LoadingOutlined } from '@ant-design/icons';
import { useDispatch } from '@redux';
import { forgotPasswordUser, verifyResetCode } from '@redux/auth/actions';
import { Button, Form, Spin, Statistic } from 'antd';
import { InputOTP } from 'antd-input-otp';
import PublicHeader from 'layout/PublicLayout/PublicHeader';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function VerificationCode({ data, setData, setStep }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showResend, setShowResend] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleResendOTP = () => {
    setLoading(true);
    dispatch(forgotPasswordUser({ email: data?.email })).then(({ payload }) => {
      setLoading(false);
      if (payload?.success) {
        setShowResend(false);
      }
    });
  };

  const handleConfirmOTP = (values) => {
    setLoading(true);
    dispatch(verifyResetCode({ ...data, code: values.otp?.join('') })).then(
      ({ payload }) => {
        setLoading(false);
        if (payload?.success) {
          setData((data) => ({ ...data, code: values.otp?.join('') }));
          setStep('newPassword');
        }
      },
    );
  };

  return (
    <div>
      <PublicHeader
        title="common.auth.enterResetCode"
        subtitle="common.auth.enterResetCodeSub"
      />
      <Form onFinish={handleConfirmOTP} layout="vertical">
        <Form.Item
          name="otp"
          rules={[
            {
              required: true,
              message: t('input.otp.validateMsg.required'),
            },
          ]}
        >
          <InputOTP
            autoFocus
            // inputType="numeric"
            length={6}
            inputClassName="!w-[45px] !h-[45px]"
          />
        </Form.Item>

        <Button
          htmlType="submit"
          type="primary"
          className="mt-[10px] w-full"
          loading={loading}
        >
          {t('button.confirm')}
        </Button>
      </Form>
      <div className="flex items-center justify-center mt-[20px] text-[14px] gap-1">
        <span>{t('common.auth.notReceived')}</span>
        {showResend ? (
          <span
            className="cursor-pointer text-[#6852D3]"
            onClick={handleResendOTP}
          >
            {loading ? (
              <Spin indicator={<LoadingOutlined spin />} size="small" />
            ) : (
              t('common.auth.resend')
            )}
          </span>
        ) : (
          <Statistic.Countdown
            value={Date.now() + 7200 * 1000}
            onFinish={() => setShowResend(true)}
            valueStyle={{ color: '#6852D3', fontSize: '14px' }}
          />
        )}
      </div>
    </div>
  );
}
